// @flow

import { I13N_CATEGORY_SAGA, I13N_TYPE_EXCEPTION } from 'Lib/constants/i13nSpec';
import { debugI13nTinderEvents as debug } from 'Lib/debug';
import type { PayloadType } from 'Lib/i13n/ReactI13nGTag';
import requestIdleCallbackManager from 'Lib/requestIdleCallbackManager';

/**
 * @class i13nTinderEvents
 */
class i13nTinderEvents {
  sendLogsIsEnabled: boolean;
  _unsubscribeFn: function;

  setSendLogsIsEnabled = (isEnabled: boolean): void => {
    this.sendLogsIsEnabled = isEnabled;
  };

  getPlugin = (): Object => {
    if (!__CLIENT__) {
      return {};
    }
    debug('initialized i13nTinderEvents plugin');
    return {
      name: 'eventsSDK',
      eventHandlers: {
        [I13N_TYPE_EXCEPTION]: this._executeHandlerAtIdleIfEnabled(
          this._exceptionHandler,
          (e) => e.category === I13N_CATEGORY_SAGA
        ),
      },
    };
  };

  _executeHandlerAtIdleIfEnabled =
    (
      handler: (PayloadType) => void | Promise<void>,
      filter?: (PayloadType) => boolean
    ): ((PayloadType) => Promise<void>) =>
    async (payload: PayloadType): Promise<void> => {
      if (!payload || (filter && !filter(payload))) return;
      // wait until event occurs to read lever
      const { shouldSendLog } = await import(
        './i13nTinderEventsHandler' /* webpackChunkName: 'async-i13nTinderEventsHandler' */
      );
      if (shouldSendLog()) {
        requestIdleCallbackManager.addTask(() => handler(payload));
      }
    };

  _exceptionHandler = async (payload: PayloadType): Promise<void> => {
    const { sendExceptionEvent } = await import(
      './i13nTinderEventsHandler' /* webpackChunkName: 'async-i13nTinderEventsHandler' */
    );
    await sendExceptionEvent(payload);
  };
}

export default i13nTinderEvents;
